export default "__VITE_ASSET__Cvfo8Y7G__"